import style from '../../../styles/Weather/weather_hourly_conditions'
import Title from '../Title'
import Hour from './Hour'

const HourlyConditions = ({ forecast }) => {
  const [highestTemp, lowestTemp] =
    forecast?.reduce(
      // get the lowest and highest temp from the actual hourly forecast
      ([max, min], hour) => {
        const temp = parseInt(hour?.temperature) || 0
        return [Math.max(max, temp), Math.min(min, temp)]
      } /* c8 ignore next 2 */,
      [0, 150]
    ) || []

  return (
    <div className='wrapper'>
      <Title title='Hourly forecast' />
      <div className='hourly-container'>
        <div className='scroll-wrapper'>
          <div className='hours'>
            {forecast?.map((hour, index) => (
              <Hour key={index} hour={hour} high={highestTemp} low={lowestTemp} />
            ))}
          </div>
        </div>
      </div>
      <style jsx>{style}</style>
    </div>
  )
}

export default HourlyConditions
